import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import {
  Card as ShadcnCard,
  CardAction,
  CardDescription,
  CardHeader as ShadcnCardHeader,
  CardTitle,
} from '@/components/ui/card';

/**
 * COMPATIBILITY SHIM — legacy Card API over shadcn's.
 *
 * Legacy Card is a single padded box with a numeric `padding` prop; shadcn's is
 * a compound with its own internal spacing. The shim keeps the old surface for
 * the 39 call sites by disabling shadcn's vertical rhythm and applying the
 * requested padding directly.
 */

export interface CardProps {
  children: ReactNode;
  padding?: number;
  style?: React.CSSProperties;
  className?: string;
}

export function Card({ children, padding = 20, style, className }: CardProps) {
  return (
    <ShadcnCard
      // gap-0/py-0 undo the compound's own rhythm — legacy callers own their
      // internal layout and pass a single padding value.
      className={cn('gap-0 py-0', className)}
      style={{ padding, ...style }}
    >
      {children}
    </ShadcnCard>
  );
}

export function CardHeader({
  title,
  subtitle,
  right,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <ShadcnCardHeader className="px-0 pb-4 [.border-b]:pb-4">
      <CardTitle className="font-heading text-lg font-bold">{title}</CardTitle>
      {subtitle && <CardDescription className="text-13">{subtitle}</CardDescription>}
      {right && <CardAction>{right}</CardAction>}
    </ShadcnCardHeader>
  );
}
